<template>
  <div class="scene">
    <a :href="PCUrl" class="go-back">返回首页</a>
    <div class="top">
        <img src="../assets/logo.png" alt="">
        <p>PIMC评估您的沟通状态</p>
    </div>
    <div class="box">
        <h1>请选择您要参加的评估场景</h1>
        <ul>
            <li v-for="(item,index) in scene" :key="index" @click="goCheck(item.scene_id)"><img :src="require('../assets/scene'+item.scene_id+'.jpg')" alt=""></li>
        </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Cmind-index',
  data () {
    return {
      realname: '',
      oldMobile: localStorage.CmindLoginMobile||123,
      mobile:'',
      pimcencypt:localStorage.pimcencypt||'',
      // pimcencypt:'',
      scene:'',
      userMessage:this.$route.query.u||'',
      user_id:'',
    }
  },
  created(){
    this.getScene()
    this.login()
  },
  mounted(){
    // $.post(`https://api.interview.beta.pimconline.com/PcProject/getQuestion?${this.getTime()}`,{
    //     pimcencypt:this.pimcencypt,
    //     scene_id:'',
    //     refresh:0
    // },function(res){});
  },
  methods:{
    login(){
      //先判断地址是否有效
      try{
        let user = JSON.parse(this.base64_decode((this.userMessage).replace(/[ ]/g,'+')));
        if(user.realname && user.mobile){
          this.realname = user.realname
          this.mobile = user.mobile
          console.log(user)
        }else{
          console.log('不存在realname或mobile')
          alert('地址有误401')
          return
        }
      }catch(e){
        console.log('参数格式不对:',this.base64_decode(this.userMessage)||'空')
        alert('地址有误402')
        return
      }
      // 若当前用户与上一次登录用户不一致，清空pimcencypt
      if(this.mobile!=this.oldMobile){
        this.pimcencypt = ''
      }
      if(!this.pimcencypt){
        this.getPimcencypt().then((e)=>{
          this.$http.post(`/PcProject/register?${this.getTime()}`,
            {realname:this.realname,mobile:this.mobile,pimcencypt:e}
          ).then(res => {
            if(!res.data.code){
              this.user_id = res.data.data.user_id
              this.hasLogin = true
              localStorage.setItem("CmindLoginMobile", res.data.data.mobile);
            }else{
              this.hasLogin = false
            }
          }).catch(err => {
            alert('登录失败，请检查网络')
          })
        }).catch((err)=>{
          alert(err)
        })
      }else{
        this.$http.get(`/PcProject/checkLogin?${this.getTime()}`,
          {params:{pimcencypt:this.pimcencypt}}
        ).then(res => {
          if(!res.data.code){
            this.user_id = res.data.data.user_id
            this.hasLogin = true
            localStorage.setItem("CmindLoginMobile", res.data.data.mobile);
          }else if(res.data.code==1){
            this.$http.post(`/PcProject/register?${this.getTime()}`,{
              realname:this.realname,
              mobile:this.mobile,
              pimcencypt:this.pimcencypt
            }).then(res => {
              if(!res.data.code){
                this.user_id = res.data.data.user_id
                this.hasLogin = true
                localStorage.setItem("CmindLoginMobile", res.data.data.mobile);
              }else{
                this.hasLogin = false
              }
            }).catch(err => {
                console.log('register登录接口失败')
            })
          }
        }).catch(err => {
            console.log('checkLogin检查登录接口失败')
        })
      }
    },
    goCheck(id){
      if(!this.hasLogin){
        alert('请先登录')
        return
      }
      let obj = {scene_id: id,user_id:this.user_id}
      let str = this.base64_encode(JSON.stringify(obj))
      this.$router.push({name: 'check',query: {e:str}})
    },
    getPimcencypt(){
      return new Promise((resolve, reject)=>{
        this.$http.get(`/PcProject/getencypt`).then(res => {
          if(!res.data.code){
            localStorage.setItem("pimcencypt", res.data.data.pimcencypt);
            resolve(res.data.data.pimcencypt);
          }
        }).catch(err => {
            reject("获取信息失败，请检查网络")
        })
      })
    },
    getScene(){
      this.$http.get(`/PcProject/getScene?${this.getTime()}`).then(res => {
        if(!res.data.code){
          this.scene = res.data.data
        }
      }).catch(err => {
        alert('获取场景失败，请检查网络')
      })
    },
  }
}
</script>

<style scoped>
  /* .box{
    width: 800px;margin: 8% auto 0;border-radius: 10px;
    border: 1px solid #ddd;background: rgba(255,255,255,0.7);
    padding-bottom: 40px;height: 400px;box-sizing: border-box;
  } */
  .box h1{
    font-size: 24px;color: #2fa4e7;line-height: 100px;
    font-weight: normal;
  }
  .box ul{display: flex;margin: 20px 20px;}
  .box ul li{margin: 0 5px;cursor: pointer;}
  .box ul li img{width: 100%;}
</style>


// WEBPACK FOOTER //
// src/components/index.vue